import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', () => {
  const isShowLoginModal = ref(false)
  const isShowSignUpModal = ref(false)
  const isShowForgotPasswordModal = ref(false)
  const isShowResetPasswordModal = ref(false)
  const isShowSetMyStoreModal = ref(false)
  const isSetMyStoreAutoLocate = ref(false)
  const isShowQuickviewModal = ref(false)
  const isQuickviewEditMode = ref(false)
  const loginEmail = ref('') // Can be used to prefill the email field across various components
  const currentSelectedProduct = ref<FlattenedProduct | null>(null)
  const isHeaderHidden = ref(false)

  function selectNearestStore() {
    isSetMyStoreAutoLocate.value = true
  }

  return {
    isShowLoginModal,
    isShowSignUpModal,
    isShowForgotPasswordModal,
    isShowResetPasswordModal,
    isShowSetMyStoreModal,
    isSetMyStoreAutoLocate,
    isShowQuickviewModal,
    isQuickviewEditMode,
    loginEmail,
    currentSelectedProduct,
    isHeaderHidden,
    selectNearestStore,
  }
})
